import { Attachment, Delete } from '@mui/icons-material'
import {
  Divider,
  List,
  Typography,
  Button as MButton,
  Alert
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Chip, Button, IconButton } from 'components'
import { API_URL } from 'config'
import { useTrackingModalStore } from 'modules/orders/components/Tracking/trackingModalStore'
import {
  useDeleteItemAccompaniment,
  useLoadItemAttachments
} from 'modules/orders/hooks'
import { useMemo, useState } from 'react'
import { HiPlus } from 'react-icons/hi'

type Props = {
  okButtonLabel?: string
  cancelButtonLabel?: string
  buttonLabel?: string
  onClose?: (ok: boolean) => void
  data: any
  isView?: boolean
}

const ListItem = ({ children }: any) => {
  return <li>{children}</li>
}

export function ItemAttachments(props: Props) {
  const {
    isView,
    data,
    okButtonLabel = 'Confirmar',
    cancelButtonLabel = 'Cancelar',
    onClose
  } = props
  const [isOpen, setOpen] = useState(false)
  const setModalOpen = useTrackingModalStore.useSetModalOpen()
  const setData = useTrackingModalStore.useSetData()

  const { data: itemAttachments } = useLoadItemAttachments({
    orderId: data.orderId,
    sequence: data.item.sequence
  })

  const { mutate: deleteAttach } = useDeleteItemAccompaniment()

  const handleClickTracking = () => {
    setOpen(true)
  }

  const handleClose = (ok: boolean) => {
    setOpen(false)
    onClose?.(ok)
  }

  const handleClickAddTracking = () => {
    setModalOpen(true)
    setData(data)
  }

  const handleClickDelete = (accompanimentId: number) => {
    deleteAttach(accompanimentId)
  }

  const totalItems =
    useMemo(
      () => itemAttachments?.meta?.query?.totalItems,
      [itemAttachments?.meta?.query?.totalItems]
    ) || 0

  const apiUrl = API_URL

  return (
    <div>
      <Chip
        label={`Acompanhamentos (${totalItems})`}
        color="default"
        onClick={handleClickTracking}
        disabled={!data?.orderId}
        sx={{
          display: 'flex',
          justifyContent: 'center'
        }}
        icon={<Attachment />}
      />

      <Dialog open={isOpen} onClose={handleClose} maxWidth="md">
        <DialogTitle id="alert-dialog-title">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'start'
            }}
          >
            <div>
              <Typography variant="h5">Acompanhamentos</Typography>
              <Typography variant="caption">{`${data?.item?.id} | ${data?.item?.sequence} | ${data?.item?.configurationId}`}</Typography>
            </div>
            {!isView && (
              <div>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<HiPlus />}
                  onClick={handleClickAddTracking}
                >
                  Novo Acompanhamento
                </Button>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogContent dividers style={{ width: 500 }}>
          {!totalItems && <Alert severity="info">Não há dados!</Alert>}

          <List>
            {itemAttachments?.data.map((accompaniment: any, i) => (
              <>
                {console.log(accompaniment)}
                <ListItem>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start'
                    }}
                  >
                    <div>
                      <Typography variant="subtitle2">
                        {accompaniment?.subject || ''}
                      </Typography>
                      <Typography variant="body2">
                        {accompaniment?.text || ''}
                      </Typography>
                    </div>
                    {!isView && (
                      <div>
                        <IconButton
                          size="small"
                          onClick={() => {
                            handleClickDelete(accompaniment.id)
                          }}
                        >
                          <Delete sx={{ color: '#e64747' }} />
                        </IconButton>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      width: '100%',
                      flexDirection: 'row'
                    }}
                  >
                    {accompaniment?.attachments
                      ?.filter(
                        (item: string) =>
                          item.replace(`${apiUrl}/media/files?fileId=`, '')
                            .length > 0
                      )
                      ?.map((attach: any, index: number) => (
                        <div key={attach} style={{ margin: 8 }}>
                          <MButton
                            href={attach}
                            target="__blank"
                            download={attach}
                            style={{ textDecoration: 'none', color: '#0C95EB' }}
                            variant="text"
                            size="small"
                            endIcon={<Attachment />}
                          >
                            anexo {index + 1}
                          </MButton>
                        </div>
                      ))}
                  </div>
                  {i < totalItems - 1 && (
                    <Divider style={{ paddingBottom: 16, marginBottom: 16 }} />
                  )}
                </ListItem>
              </>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={() => handleClose(false)}>
            {cancelButtonLabel}
          </Button>
          <Button onClick={() => handleClose(true)}>{okButtonLabel}</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
